<!-- START Dialog: Trial Ended -->
<p-dialog
    header=""
    [(visible)]="showDialog"
    [closable]="false"
    [closeOnEscape]="true"
    [modal]="true"
    [style]="{ width: '40vw' }"
    [breakpoints]="{
        '1200px': '80vw',
        '800px': '100vw',
    }"
>
    <div
        class="text-center mb-16"
        style="
            background-image: url(&quot;/assets/images/trial-end.png&quot;);
            height: 16vh;
            background-size: contain;
            background-repeat: no-repeat;
            background-position-x: center;
        "
    ></div>

    <ng-template pTemplate="content">
        <h1 class="mb-4 text-center">{{ "dialog_trialended_header" | translate }}</h1>
        <p class="mb-4 text-center">
            {{ "dialog_trialended_text1" | translate }}<br />
            {{ "dialog_trialended_text2" | translate }}<br />
            {{ "dialog_trialended_text3" | translate }}
        </p>
    </ng-template>

    <ng-template pTemplate="footer">
        <div class="flex justify-between w-full">
            <div class="text-center">
                <p-button
                    pRipple
                    severity="danger"
                    type="button"
                    styleClass="p-button-text"
                    label="{{ 'dialog_trialended_button_downgrade' | translate }}"
                    (click)="trialEndedDowngrade.emit()"
                >
                </p-button>
            </div>
            <div>
                <p-button
                    pRipple
                    type="button"
                    styleClass="p-button-text"
                    label="{{ 'dialog_trialended_button_sales' | translate }}"
                    (click)="trialEndedSales.emit()"
                ></p-button>
                <p-button
                    pRipple
                    type="button"
                    styleClass="p-button"
                    label="{{ 'dialog_trialended_button_upgrade' | translate }}"
                    (click)="trialEndedUpgrade.emit()"
                >
                </p-button>
            </div>
        </div>
    </ng-template>
</p-dialog>
<!-- END Dialog: Trial Ended -->
